export default __webpack_public_path__ + "static/media/19.b46ae4ea.png";